// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__WQorD","thick":"Divider_thick__YEA18","noMargin":"Divider_noMargin__p1n2U"};